import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaDireccion } from '../_direccion.js';

/**
 * El costeo por receta. Fase 8, tarea 22.
 *
 * CUELGA DE `_direccion`, EL GRUPO DEL ADMINISTRADOR, porque el costo de un producto frente a su precio
 * de carta es la cifra con la que se fija ese precio, y fijarlo es suyo: la calculadora del precio
 * publicado en Umashi vive en este mismo grupo. `rep.f_costo_receta` admite además al jefe de
 * operarios y a la contadora; el grupo puede ser más angosto que la función, nunca más ancho.
 *
 * Y NUNCA AL ALCANCE DEL OPERARIO: la función le contesta `42501`, que es la corrección de la tarea 17
 * para no mostrarle un margen del cien por ciento sobre un costo que no puede ver.
 *
 * El componente llega a pedido, como los demás hijos de este grupo, y por la misma razón.
 */
export const rutaCosteoReceta = createRoute({
  getParentRoute: () => rutaDireccion,
  path: '/costeo-receta',
  component: lazyRouteComponent(() => import('./costeo-receta-pantalla.js'), 'RutaCosteoReceta'),
});
